module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/04e10c82d2a75d397ca963c1a9f9e1e7.svg";